// extracted by mini-css-extract-plugin
export default {"aboutModule":"_2b480ccd","aboutModuleInner":"_79e2f913","aboutColumn":"_8d06d261","additionalOptionsWrapper":"_1bab36c0","paragraphText":"_e7500b49"};